import { render } from "./QuestionMenu.vue?vue&type=template&id=76e26fda&scoped=true"
import script from "./QuestionMenu.vue?vue&type=script&lang=js"
export * from "./QuestionMenu.vue?vue&type=script&lang=js"

import "./QuestionMenu.vue?vue&type=style&index=0&id=76e26fda&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e26fda"]])

export default __exports__